import { cn } from "@/lib/utils";

export function LoadingSpinner({ className }: { className?: string }) {
  return (
    <div
      id="loading-spinner"
      className={cn(
        "animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full",
        className,
      )}
    ></div>
  );
}
